import React, { useState } from 'react';
import { 
  ExpandMore,
  ExpandLess,
  Help,
  ShoppingCart,
  Payment,
  LocalShipping,
  Security,
  AccountCircle,
  Store,
  Assignment,
  ContactSupport
} from '@mui/icons-material';

interface FAQItem {
  id: number;
  question: string;
  answer: string;
  category: 'general' | 'shopping' | 'payment' | 'shipping' | 'account' | 'seller' | 'security';
  icon: React.ReactNode;
}

const FAQPage: React.FC = () => {
  const [expandedId, setExpandedId] = useState<number | null>(null);
  const [activeCategory, setActiveCategory] = useState<string>('all');

  const faqItems: FAQItem[] = [
    {
      id: 1,
      question: "ما هو بازار ماركت بليس؟",
      answer: "بازار ماركت بليس هو منصة تجارة إلكترونية مصرية متكاملة تربط بين البائعين والمشترين في سوق رقمي آمن ومنظم. نحن نقدم أدوات متقدمة لإدارة المتاجر وتسهيل عمليات البيع والشراء مع ضمان تجربة مستخدم متميزة.",
      category: 'general',
      icon: <Help />
    },
    {
      id: 2,
      question: "كيف يمكنني التسجيل في المنصة؟",
      answer: "يمكنك التسجيل عن طريق النقر على زر 'تسجيل' في أعلى الصفحة، ثم إدخال بياناتك الأساسية (الاسم، البريد الإلكتروني، كلمة المرور). سيتم إرسال رابط تفعيل إلى بريدك الإلكتروني. بعد التفعيل، يمكنك إكمال بيانات ملفك الشخصي.",
      category: 'account',
      icon: <AccountCircle />
    },
    {
      id: 3,
      question: "كيف يمكنني إضافة منتجات إلى عربة التسوق؟",
      answer: "تصفح المنتجات المتاحة، انقر على المنتج المطلوب، ثم اضغط على زر 'أضف إلى السلة'. يمكنك تعديل الكمية من صفحة المنتج أو من صفحة السلة نفسها.",
      category: 'shopping',
      icon: <ShoppingCart />
    },
    {
      id: 4,
      question: "ما هي طرق الدفع المتاحة؟",
      answer: "نوفر عدة طرق دفع آمنة: بطاقات الائتمان والخصم، فوري، محافظ رقمية (فودافون كاش، أورنج كاش)، والدفع عند الاستلام (متاح لبعض المنتجات). جميع المعاملات مشفرة وآمنة.",
      category: 'payment',
      icon: <Payment />
    },
    {
      id: 5,
      question: "ما هي مدة التوصيل؟",
      answer: "تتراوح مدة التوصيل بين 2-7 أيام عمل حسب الموقع الجغرافي والمنتج. يمكنك تتبع حالة الطلب من خلال حسابك. للمناطق النائية، قد تستغرق مدة إضافية 2-3 أيام.",
      category: 'shipping',
      icon: <LocalShipping />
    },
    {
      id: 6,
      question: "كيف يمكنني إرجاع منتج؟",
      answer: "يمكنك طلب إرجاع المنتج خلال 14 يومًا من تاريخ الاستلام في حالة وجود عيب مصنعي أو عدم مطابقة المنتج للوصف. اتصل بدعم العملاء أو استخدم نموذج الإرجاع من خلال صفحة الطلب في حسابك.",
      category: 'shopping',
      icon: <Assignment />
    },
    {
      id: 7,
      question: "كيف يمكنني فتح متجر على المنصة؟",
      answer: "اذهب إلى صفحة 'كن بائعًا'، املأ نموذج التسجيل، وارفع المستندات المطلوبة (سجل تجاري، بطاقة ضريبية، هوية). سيقوم فريقنا بمراجعة طلبك والرد خلال 48 ساعة عمل.",
      category: 'seller',
      icon: <Store />
    },
    {
      id: 8,
      question: "هل بياناتي الشخصية آمنة؟",
      answer: "نعم، نستخدم أحدث تقنيات التشفير (SSL/TLS) لحماية بياناتك. نحن ملتزمون بسياسة خصوصية صارمة ولا نشارك بياناتك مع أي طرف ثالث دون موافقتك. يمكنك الاطلاع على سياسة الخصوصية الكاملة من خلال الرابط المخصص.",
      category: 'security',
      icon: <Security />
    },
    {
      id: 9,
      question: "كيف يمكنني تغيير كلمة المرور؟",
      answer: "سجل الدخول إلى حسابك، انتقل إلى 'الملف الشخصي' > 'تغيير كلمة المرور'. أدخل كلمة المرور الحالية ثم كلمة المرور الجديدة مرتين. تأكد من اختيار كلمة مرور قوية تحتوي على أحرف كبيرة وصغيرة وأرقام ورموز.",
      category: 'account',
      icon: <AccountCircle />
    },
    {
      id: 10,
      question: "ماذا أفعل إذا نسيت كلمة المرور؟",
      answer: "انقر على 'نسيت كلمة المرور' في صفحة تسجيل الدخول، أدخل بريدك الإلكتروني المسجل. ستتلقى رابط إعادة تعيين كلمة المرور في بريدك خلال دقائق. اتبع التعليمات لإنشاء كلمة مرور جديدة.",
      category: 'account',
      icon: <AccountCircle />
    },
    {
      id: 11,
      question: "هل توجد رسوم إضافية على المنتجات؟",
      answer: "يتم عرض السعر النهائي للمنتج بما في ذلك الضريبة عند إضافته للسلة. رسوم الشحن تظهر بشكل منفصل وتعتمد على الوزن والموقع. لا توجد رسوم خفية أو مفاجئة.",
      category: 'payment',
      icon: <Payment />
    },
    {
      id: 12,
      question: "كيف يمكنني تتبع طلبي؟",
      answer: "بعد تأكيد الطلب، ستتلقى رقم تتبع. يمكنك استخدامه في صفحة 'تتبع الطلب' على الموقع أو من خلال حسابك في قسم 'طلباتي'. ستتلقى أيضًا تحديثات عبر البريد الإلكتروني والواتساب.",
      category: 'shipping',
      icon: <LocalShipping />
    },
    {
      id: 13,
      question: "ما هي ساعات عمل خدمة العملاء؟",
      answer: "نعمل من الساعة 10 صباحًا حتى 10 مساءً (بتوقيت مصر) طوال أيام الأسبوع. يمكنك التواصل عبر: البريد الإلكتروني: support@bazaar-marketplace.com، واتساب: +20 150 332 3006، أو نموذج الاتصال على الموقع.",
      category: 'general',
      icon: <ContactSupport />
    }
  ];

  const categories = [
    { id: 'all', label: 'الكل', icon: <Help /> },
    { id: 'general', label: 'عام', icon: <Help /> },
    { id: 'account', label: 'الحساب', icon: <AccountCircle /> },
    { id: 'shopping', label: 'التسوق', icon: <ShoppingCart /> },
    { id: 'payment', label: 'الدفع', icon: <Payment /> },
    { id: 'shipping', label: 'الشحن', icon: <LocalShipping /> },
    { id: 'seller', label: 'البائع', icon: <Store /> }
  ];

  const filteredItems = activeCategory === 'all' 
    ? faqItems 
    : faqItems.filter(item => item.category === activeCategory);

  const toggleExpand = (id: number) => {
    setExpandedId(expandedId === id ? null : id);
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white" dir="rtl">
      <div className="max-w-5xl mx-auto p-4 sm:p-6 lg:p-8">
        
        {/* Header Section */}
        <div className="mb-12 text-center">
          <div className="inline-flex items-center justify-center mb-6">
            <div className="relative">
              <div className="absolute inset-0 bg-gradient-to-r from-primary to-primary-dark rounded-2xl blur-lg opacity-30"></div>
              <div className="relative bg-gradient-to-r from-primary to-primary-dark p-5 rounded-2xl shadow-xl">
                <Help className="text-white text-4xl" />
              </div>
            </div>
          </div>
          
          <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            الأسئلة الشائعة
          </h1>
          
          <div className="h-1.5 w-32 bg-gradient-to-r from-primary to-primary-dark mx-auto rounded-full mb-4"></div>
          
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            ابحث عن إجابات لأسئلتك أو تواصل مع فريق الدعم للحصول على مساعدة إضافية
          </p>
        </div>

        {/* Search Bar */}
        <div className="mb-8">
          <div className="relative">
            <input
              type="text"
              placeholder="ابحث في الأسئلة الشائعة..."
              className="w-full p-4 pl-12 rounded-xl border border-gray-300 focus:border-primary focus:ring-2 focus:ring-primary/20 transition-all duration-300"
              onChange={(e) => {
                // Add search functionality if needed
              }}
            />
            <div className="absolute right-4 top-1/2 transform -translate-y-1/2 text-gray-400">
              <Help />
            </div>
          </div>
        </div>

        {/* Categories */}
        <div className="mb-8">
          <div className="flex flex-wrap gap-3 justify-center">
            {categories.map((category) => (
              <button
                key={category.id}
                onClick={() => setActiveCategory(category.id)}
                className={`flex items-center gap-2 px-4 py-2 rounded-lg transition-all duration-300 ${
                  activeCategory === category.id
                    ? 'bg-gradient-to-r from-primary to-primary-dark text-white shadow-lg'
                    : 'bg-white text-gray-700 border border-gray-300 hover:border-primary hover:shadow-md'
                }`}
              >
                <span>{category.icon}</span>
                <span>{category.label}</span>
              </button>
            ))}
          </div>
        </div>

        {/* FAQ Items */}
        <div className="space-y-4 mb-12">
          {filteredItems.map((item) => (
            <div
              key={item.id}
              className="bg-white rounded-xl shadow-sm hover:shadow-md transition-shadow duration-300 overflow-hidden border border-gray-200"
            >
              <button
                onClick={() => toggleExpand(item.id)}
                className="w-full flex items-center justify-between p-6 text-right"
              >
                <div className="flex items-start gap-4">
                  <div className={`p-3 rounded-lg ${
                    expandedId === item.id 
                      ? 'bg-gradient-to-r from-primary/20 to-primary/30' 
                      : 'bg-gray-100'
                  }`}>
                    <span className={`${
                      expandedId === item.id ? 'text-primary' : 'text-gray-600'
                    }`}>
                      {item.icon}
                    </span>
                  </div>
                  <div className="flex-1 text-right">
                    <h3 className="text-lg font-semibold text-gray-900 mb-1">
                      {item.question}
                    </h3>
                  </div>
                </div>
                <div className="flex-shrink-0 ml-4">
                  {expandedId === item.id ? (
                    <ExpandLess className="text-primary" />
                  ) : (
                    <ExpandMore className="text-gray-400" />
                  )}
                </div>
              </button>
              
              {expandedId === item.id && (
                <div className="px-6 pb-6 pr-16">
                  <div className="pl-4 border-r-4 border-primary bg-blue-50/50 rounded-lg p-4">
                    <p className="text-gray-700 leading-relaxed">{item.answer}</p>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>

        {/* Contact Section */}
        <div className="bg-gradient-to-r from-primary/10 to-primary/20 rounded-2xl p-8 text-center">
          <ContactSupport className="text-primary text-4xl mb-4 mx-auto" />
          <h3 className="text-2xl font-bold text-gray-900 mb-3">
            لم تجد إجابة لسؤالك؟
          </h3>
          <p className="text-gray-600 mb-6 max-w-2xl mx-auto">
            فريق الدعم لدينا جاهز لمساعدتك على مدار الساعة
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <a
              href="mailto:support@bazaar-marketplace.com"
              className="px-6 py-3 bg-gradient-to-r from-primary to-primary-dark text-white rounded-lg hover:opacity-90 transition-opacity duration-300"
            >
              إرسال بريد إلكتروني
            </a>
            <a
              href="https://wa.me/201503323006"
              target="_blank"
              rel="noopener noreferrer"
              className="px-6 py-3 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors duration-300"
            >
              محادثة واتساب
            </a>
            <a
              href="/contact"
              className="px-6 py-3 bg-white border border-primary text-primary rounded-lg hover:bg-primary hover:text-white transition-all duration-300"
            >
              نموذج الاتصال
            </a>
          </div>
        </div>

        {/* Footer */}
        <div className="mt-12 pt-8 border-t border-gray-200 text-center">
          <div className="text-gray-500 text-sm leading-relaxed max-w-2xl mx-auto space-y-2">
            <p>
              آخر تحديث: {new Date().toLocaleDateString('ar-EG')}
            </p>
            <p className="text-gray-400">
              جميع الحقوق محفوظة © {new Date().getFullYear()} بازار ماركت بليس
            </p>
          </div>

          <div className="mt-8 flex flex-wrap justify-center gap-4">
            <a href="/terms-conditions" className="text-primary hover:underline text-sm">
              شروط الاستخدام
            </a>
            <span className="text-gray-300">|</span>
            <a href="/policies" className="text-primary hover:underline text-sm">
              سياسة الخصوصية
            </a>
            <span className="text-gray-300">|</span>
            <a href="/contact" className="text-primary hover:underline text-sm">
              اتصل بنا
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FAQPage;